import { css } from 'styled-components'

export const typography = css`
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
  
html {
    line-height: unset;
    -webkit-text-size-adjust: unset;
}
  
body {
    font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI';
}

h1 {
    font-family: 'Barlow', sans-serif;
    font-weight: bold;
    line-height: 110%;
}
h2 {
    font-family: 'Barlow', sans-serif;
    font-weight: bold;
    font-size: 32px;
    line-height: 110%;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
}
h3 {
    font-family: 'Barlow', sans-serif;
    font-weight: bold;
    font-size: 28px;
    line-height: 110%;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
}
h4 {
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
}
h5 {
    margin-block-start: 1.67em;
    margin-block-end: 1.67em;
}

h6 {
    margin-block-start: 2.33em;
    margin-block-end: 2.33em;
}
.eyebrow-headline {
    font-family: 'Barlow', sans-serif;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.1em;
    line-height: 100%;
    text-decoration: underline;
    text-transform: uppercase;
}
.subtitle {
    font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 18px;
    font-weight: normal;
}
body {
    font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-weight: normal;
}
a {
    color: currentColor;
}
@media only screen and (min-width: 940px) {
    h2 { font-size: 48px; }
    h3 { font-size: 36px; }
    .subtitle { font-size: 24px; }
}
`
